/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/assets/js/how-to-use.js ***!
  \*************************************/
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var HowToUse = /*#__PURE__*/function () {
  function HowToUse() {
    _classCallCheck(this, HowToUse);

    this.selectors = {
      section: ".how-to-use-section",
      swiper: ".swiper.how-to-use-row"
    };
    this.modificators = {
      active: "active"
    };
    this.activeSlider = null;
  }

  _createClass(HowToUse, [{
    key: "initSlider",
    value: function initSlider(slider, section) {
      if (this.activeSlider) {
        this.activeSlider.destroy();
      }

      var sliderOptions = JSON.parse(slider.getAttribute('data-swiper-settings'));
      var pagination = section.querySelector('.swiper-pagination');

      var options = _objectSpread({
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: false,
        centeredSlides: false,
        pagination: {
          el: pagination,
          clickable: true
        }
      }, sliderOptions);

      this.activeSlider = new Swiper(slider, options);
    }
  }, {
    key: "handleSections",
    value: function handleSections() {
      var _this = this;

      var sections = document.querySelectorAll(this.selectors.section);
      if (!sections.length) return;
      sections.forEach(function (section) {
        var slider = section.querySelector(_this.selectors.swiper);

        _this.initSlider(slider, section);
      });
      var text_content = document.querySelectorAll('.text-content');
      setTimeout(function () {
        text_content.forEach(function (el) {
          var btn = el.closest('.how-to-use').querySelector('.expand-btn');

          if (el.clientHeight < 68) {
            btn.classList.add('hiddenn');
          } else {
            el.classList.add('collapsed');
          }
        });
      }, 200);
      var toggleButtons = document.querySelectorAll(".expand-btn");
      toggleButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.currentTarget.nextElementSibling.classList.toggle('collapsed');

          if (event.currentTarget.querySelector('span').innerHTML === 'View Less') {
            event.currentTarget.querySelector('span').innerText = 'View More';
          } else {
            event.currentTarget.querySelector('span').innerText = 'View Less';
          }
        });
      });
    }
  }]);

  return HowToUse;
}();

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    var howToUseEvent = new HowToUse();
    howToUseEvent.handleSections();
    window.HowToUse = howToUseEvent;
  }
});
/******/ })()
;